/*
 * @Author: Ryan
 * @Date: 2026-02-02
 * @Description: CTA section - Experience Fast & Precise Image Translation with AI
 */
import React from 'react';

import { scrollToTop } from '@/utils/landing/scrollToTop';

// 箭头图标
const ArrowRightIcon: React.FC = () => (
  <svg viewBox="64 64 896 896" fill="currentColor" width="1em" height="1em">
    <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z" />
  </svg>
);

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        {/* Title */}
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Experience Fast & Precise Image Translation with AI
        </h2>

        {/* Description */}
        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Stop struggling with manual translations or expensive services. Transform your
          images into any language in seconds while keeping designs intact—powered by
          FalcoCut AI.
        </p>

        {/* CTA Button */}
        <button
          type="button"
          onClick={() => scrollToTop()}
          className="inline-flex items-center justify-center gap-2 px-8 py-4 text-base font-semibold text-white rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg"
          style={{
            background: 'linear-gradient(90deg, #4D2FFF 0%, #EF5CFF 100%)',
          }}
        >
          <span>Translate an Image Now</span>
          <ArrowRightIcon />
        </button>
      </div>
    </section>
  );
};

export default CTASection;
